/* Silver Gems upsell: metingen en A/B-toewijzing voor de "Klanten kopen ook"
   sectie (sg-upsell-engine) en "Shop de look" (sg-shop-the-look).
   Quick-add zelf loopt via sg-theme.js (data-sg-product-form); dit bestand
   verstuurt alleen events. Zonder analytics-toestemming via de Shopify
   Customer Privacy API verlaat er niets de browser; zonder geconfigureerd
   endpoint wordt er niets gemeten. Geen PII, geen fingerprinting. */
(function () {
  'use strict';

  /* beide secties laden dit bestand; een keer draaien is genoeg */
  if (window.__sgUpsellInit) return;
  window.__sgUpsellInit = true;

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-sg-upsell]'));
  if (!roots.length) return;

  var engineRoot = null;
  var lookRoot = null;
  roots.forEach(function (r) {
    if (r.hasAttribute('data-sg-look')) lookRoot = r;
    else engineRoot = r;
  });
  var cfgRoot = null;
  roots.forEach(function (r) {
    if (!cfgRoot && r.getAttribute('data-sg-upsell-endpoint')) cfgRoot = r;
  });
  var endpoint = cfgRoot ? cfgRoot.getAttribute('data-sg-upsell-endpoint') : '';

  /* ---------- sessie: anoniem uuid, 30 minuten rollend ---------- */

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  var SESSION_KEY = 'sg-upsell-session';
  var SESSION_TTL = 30 * 60 * 1000;

  function sessionId() {
    var now = Date.now();
    var s = null;
    try { s = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); } catch (e) {}
    if (!s || !s.id || now - (s.ts || 0) > SESSION_TTL) s = { id: uuid(), ts: now };
    s.ts = now;
    try { localStorage.setItem(SESSION_KEY, JSON.stringify(s)); } catch (e) {}
    return s.id;
  }

  var session = sessionId();

  /* ---------- A/B: engine tegenover look ----------
     Deterministische bucket uit de sessie-id, zodat een bezoeker binnen een
     sessie een vaste variant ziet. Zonder JS blijft de servergerenderde
     stand staan: engine zichtbaar, look verborgen. */

  function bucket(id) {
    var h = 0;
    for (var i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
    return h % 2;
  }

  var experiment = null;
  if (lookRoot && lookRoot.getAttribute('data-sg-look-experiment') === 'true') {
    if (engineRoot) {
      var b = bucket(session);
      experiment = { name: 'upsell_vs_look', variant: b === 0 ? 'engine' : 'look' };
      engineRoot.hidden = b !== 0;
      lookRoot.hidden = b === 0;
    } else {
      /* niets om tegen te testen: look gewoon tonen */
      lookRoot.hidden = false;
    }
  }

  /* ---------- toestemming: EU-winkel, zonder expliciet ja gaat er niets weg ---------- */

  function consentGranted() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return false;
    try {
      if (typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true;
      if (typeof cp.currentVisitorConsent === 'function') return cp.currentVisitorConsent().analytics === 'yes';
      if (typeof cp.userCanBeTracked === 'function') return cp.userCanBeTracked() === true;
    } catch (e) {}
    return false;
  }

  /* ---------- versturen ----------
     text/plain houdt het een simple request (sendBeacon met application/json
     strandt cross-origin op preflight); de API parseert de body zelf. */

  var pageRoot = cfgRoot || engineRoot || lookRoot;
  var page = {
    product: pageRoot.getAttribute('data-sg-upsell-product'),
    stone: pageRoot.getAttribute('data-sg-upsell-stone') || '',
    category: pageRoot.getAttribute('data-sg-upsell-category') || '',
    price: parseInt(pageRoot.getAttribute('data-sg-upsell-price'), 10) || 0
  };

  var pending = [];

  function transmit(body) {
    var ok = false;
    try {
      if (navigator.sendBeacon) {
        ok = navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      }
    } catch (e) { ok = false; }
    if (!ok) {
      try {
        fetch(endpoint, {
          method: 'POST',
          body: body,
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
        }).catch(function () {});
      } catch (e) {}
    }
  }

  function send(type, data) {
    if (!endpoint) return;
    var evt = {
      type: type,
      session: session,
      ts: Date.now(),
      product: page.product,
      stone: page.stone,
      category: page.category,
      price: page.price
    };
    if (experiment) {
      evt.experiment = experiment.name;
      evt.variant = experiment.variant;
    }
    if (data) for (var k in data) evt[k] = data[k];
    if (!consentGranted()) {
      if (pending.length < 50) pending.push(evt);
      return;
    }
    flush();
    transmit(JSON.stringify(evt));
  }

  function flush() {
    if (!pending.length || !consentGranted()) return;
    pending.splice(0).forEach(function (evt) { transmit(JSON.stringify(evt)); });
  }

  document.addEventListener('visitorConsentCollected', flush);

  /* ---------- events ---------- */

  function itemData(el) {
    return {
      pick: el.getAttribute('data-sg-upsell-item'),
      position: parseInt(el.getAttribute('data-sg-upsell-position'), 10) || 0,
      source: el.getAttribute('data-sg-upsell-source') || '',
      pick_stone: el.getAttribute('data-sg-upsell-item-stone') || '',
      pick_category: el.getAttribute('data-sg-upsell-item-category') || '',
      pick_price: parseInt(el.getAttribute('data-sg-upsell-item-price'), 10) || 0
    };
  }

  send('pdp_view');

  /* impressies: een keer per pick per paginaweergave, op 50% zichtbaar;
     dots en rijen delen een product-id en tellen samen een keer */
  var seenImpressions = {};
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        var el = entry.target;
        var d = itemData(el);
        io.unobserve(el);
        if (!d.pick || seenImpressions[d.source + ':' + d.pick]) return;
        seenImpressions[d.source + ':' + d.pick] = true;
        send('upsell_impression', d);
      });
    }, { threshold: 0.5 });
    roots.forEach(function (r) {
      r.querySelectorAll('[data-sg-upsell-item]').forEach(function (el) { io.observe(el); });
    });
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-sg-upsell-item]');
    if (!item || !item.closest('[data-sg-upsell]')) return;
    if (!e.target.closest('a')) return; /* quick-add is een form, geen klik-event */
    send('upsell_click', itemData(item));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-sg-upsell-add]');
    if (!form) return;
    var item = form.closest('[data-sg-upsell-item]');
    if (!item) return;
    send('upsell_add', itemData(item));
  });
})();
